import React from "react";

const TrackIcon = ({ height = 10, width = 10, color = "", className = "" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        className={className}
        color={color}
        viewBox="0 0 10 10"
        fill="none"
    >
        <path
            d="M9.04745 0.564744C9.02799 0.233944 8.74405 -0.0184468 8.41325 0.00101226L3.02257 0.318111C2.69177 0.33757 2.43938 0.62151 2.45884 0.952309C2.4783 1.28311 2.76224 1.5355 3.09304 1.51604L7.88475 1.23417L8.16662 6.02589C8.18608 6.35669 8.47002 6.60908 8.80082 6.58962C9.13162 6.57016 9.38401 6.28622 9.36455 5.95543L9.04745 0.564744ZM0.448486 9.59998L0.896932 9.99859L8.89693 0.998595L8.44849 0.599977L8.00004 0.201358L4.07398e-05 9.20136L0.448486 9.59998Z"
            fill="currentColor"
        />
    </svg>
);

export default TrackIcon;
